﻿'use strict';

if (!window.i18n) {
    window.i18n = {};
}

if (!window.i18n.languages) {
    window.i18n.languages = {};
}

window.i18n.languages['hi_HI'] = {
    vistor_upsucess:"अद्यतन सफल हुआ",
    vistor_accountUp:"खाता अपग्रेड",
    vistor_upgradeNow:"तुरंत अपग्रेड करें",
    vistor_dear:"प्रिय आगंतुकों:",
    vistor_suggest:"नमस्कार, आपको एक बेहतर उपयोगकर्ता अनुभव देने के लिए, मैं आपको सुझाव देता हूं:",
    vistor_click:"आधिकारिक खाते में अपग्रेड करने के लिए नीचे \"खाता उन्नयन\" पर क्लिक करें",
    vistor_sorry:"क्षमा करें, अतिथि खाता पासवर्ड नहीं बदल सकता है। अपने खाते की सुरक्षा के लिए, कृपया एक आधिकारिक खाते में अपग्रेड करें",

    change_useridpwd:"ते की पुष्टि करें",
    bizhong_xuanze:"मुद्रा चयन",

    optional:"ऐच्छिक",
    needBet: "फिर भी बाजी:",
    needDeposit:"जमा की जरूरत है:",

    agentCode : "निमंत्रण कोड",
    tips_fail:"दावा फेल हो गया",
    a_stauts:"सक्रिय स्थिति",

    activityDetails_zt: "सक्रिय स्थिति",
    activityDetails_hdjxz: "गतिविधि जारी है",
    activityDetails_hdwks: "गतिविधि शुरू नहीं हुई",
    activityDetails_hdyjs: "घटना खत्म हो गई है",

    a_time: `गतिविधि का समय`,
    a_status: `सक्रिय स्थिति`,
    a_rule: `इनाम के नियम`,
    a_content: `गतिविधि विवरण`,

    gameCoin:"खेल मुद्रा",

    register_chooseCurrency: "जमा मुद्रा चुनें",
    register_tips0:"*आप पंजीकरण के बाद अपनी मुद्रा नहीं बदल सकते",
    register_curInstruction:"मुद्रा विवरण:",
    register_tips1:"1. उपयोगकर्ता के मौजूदा मुद्रा का समर्थन नहीं करने वाले खेल में प्रवेश करते समय,विनिमय दर पर परिवर्तित राशि को खेल में लाया जाएगा;",
    register_tips2:"2. उपयोगकर्ता की जमा / निकासी विधि उपयोगकर्ता के वर्तमान मुद्रा समर्थन को प्रदर्शित करना है;",

    sendSuccess:"सफलतापूर्वक भेज दिया!",
    login_areaCode: 'देश कोड',
    login_selectAreaCode: 'देश या क्षेत्र का चयन करें',
    new_maxVipLV: 'बधाई हो! ! आप वर्तमान में उच्चतम स्तर पर हैं',
    currency_symbol : "₹",
    language : "भारतीय",

    new_r_rate: 'खेल में लाई गई राशि विनिमय दर रूपांतरण के बाद की राशि है',
    new_r_rate1: 'विनिमय दर：',
    new_r_money: 'वखेल में राशि：',
    new_r_tips6: '*कृपया ध्यान दें कि तीन-पार्टी गेम में स्थानांतरण केवल पूर्णांकों में ला सकता है',
    new_r_tips7: 'विनिमय दर अनुस्मारक',
    new_r_tips8: 'मुझे पता है',
    new_r_tips9: 'आप वर्तमान में प्रवेश कर रहे हैं',
    new_r_game:"खेल",

        "ActivityNew":{
        "btn_lingqu":"अब मिलें",
        "btn_back":"वापस",
        "toggle_zonghe":"व्यापक गतिविधि"
    },
    "SignIn":{
        "btnLingqu":"मिलें"
    },
    "label_text":{
        "loading_msg":"आपके लिए अपडेट रिसोर्स पैक डाउनलोड करना",
        "not_logged":"लोग इन नहीं है",
        "password":"कुंजिका:",
        "verify":"पुष्टि संख्या:",
        "verify_msg":"कृपया सत्यापन कोड दर्ज करें",
        "inPlease_enter_the":"कृपया दर्ज करें",
        "phone":"सेल फोन",
        "No":"संख्या",
        "determine":"निर्धारित",
        "receive":"प्राप्त करना",
        "Image_preview":"अवतार पूर्वावलोकन",
        "Install":"अभी स्थापित करें",
        "obtain":"मिलने पर बधाई",
        "check_update":"अपडेट्स के लिए जांच हो रही है...",
        "real_name":"वास्तविक नाम",
        "tips":"खराब खेलों का बहिष्कार करें，कोई पायरेटेड गेम नहीं。आत्म-सुरक्षा पर ध्यान दें，धोखा होने से सावधान रहें。मस्तिष्क को लाभ पहुंचाने के लिए मध्यम खेल，खेल के आदी दर्द होता है。यथोचित समय की व्यवस्था करें，स्वस्थ जीवन का आनंद लें。",
        "tishi":"नोटिस",
        "no_data":"अभी डेटा नहीं है",
        "queding":"पुष्टि करें",
        "quxiao":"रद्द करें",
        "download_new_version":"इस फ़ंक्शन का उपयोग के लिए नवीनतम संस्करण डाउनलोड करें",
        "online_kefu":"ऑनलाइन ग्राहक सेवा",
        "save_account":"खाते की जानकारी सहेजें",
        "title":"इनाम मिला"
    },
    "data_req_text":{
        "login_failure":"लॉगिन समाप्त हो गया है, कृपया फिर से लॉग इन करें"
    },
    "login_text":{
        "account_pro":"खाता संख्या खाली नहीं हो सकती, कृपया भरें!",
        "psw_pro":"पासवर्ड खाली नहीं हो सकता, कृपया भरें!",
        "vfy_pro":"सत्यापन कोड खाली नहीं हो सकता, कृपया भरें!",
        "quick_login_fail":"अतिथि लॉगिन विफल रहा",
        "account":"खाता संख्या:",
        "account_msg":"कृपया अपना खाता / फ़ोन नंबर दर्ज करें",
        "paw_msg":"कृप्या पास्वर्ड भरो",
        "Remember_acc":"मुझे याद रखना",
        "forget_paw":"पासवर्ड भूल गए?",
        "no_acc":"कोई खाता नहीं,",
        "go_reg":"पंजीकरण> पर जाएं",
        "confirm_login":"साइन-इन की पुष्टि करें",
        "quick_login":"मेहमान लॉगइन करें",
        "confirm_register":"पंजीकरण की पुष्टि करें",
        "register_cg":"पंजीकरण सफल है",
        "account_data": "खाते की जानकारी",
        "sfyz": "सत्यापन",
        "sfyz_tip": "प्रिय ग्राहक!अपने खाता सुरक्षा को सुरक्षित करने के लिए, इस लॉगइन को निम्न प्रमाणीकरण की जरूरत है कि बुराई प्रोग्राम स्वचालित ल",
        "bind_bank": "कृपया बाइंड बैंक कार्ड इनपुट करें",
        "bind_alipay": "कृपया बाइंड एलिपेल भरें",
        "bank_card": "बैंक कार्ड:",
        "alipay": "Alipay:",
        "code": "परीक्षण कोड:",
        "enter_bank_card": "कृपया बैंक कार्ड क्रमांक इनपुट करें",
        "enter_alipay": "कृपया Alipay खाता संख्या भरें",
        "enter_code": "कृपया सत्यापन कोड भरें",
    },
    "register_text":{
        "perfect_suc":"पूर्ण डेटा सफलता！",
        "perfect_err":"डेटा पूरा करने में विफल！",
        "inp_data":"कृपया पहले डेटा दर्ज करें！",
        "inp_email":"कृपया अपना ईमेल इनपुट करें",
        "inp_phone":"कृपया फ़ोन नंबर दर्ज करें",
        "inp_wx":"कृपया WeChat आईडी दर्ज करें",
        "inp_qq":"कृपया QQ नंबर दर्ज करें",
        "email":"मेलबॉक्स：",
        "wx_No":"WeChat：",
        "qq_No":"QQ：",
        "phone":"फ़ोन नंबर：",
        "user_name":"उपयोगकर्ता नाम：",
        "user_msg":"कृपया 6-12 अंकों का पत्र या नंबर खाता दर्ज करें",
        "user_pro":"6-12 अक्षर या संख्या या प्रतीकों का एक पासवर्ड दर्ज करें",
        "paw_pro":"पासवर्ड 6-12 अंकों और अक्षरों का एक संयोजन है",
        "confirm_paw_pro":"पुष्टिकरण पासवर्ड खाली नहीं हो सकता, कृपया भरें！",
        "paw_consistent":"पासवर्ड और पुष्ट पासवर्ड असंगत हैं, कृपया फिर से भरें!",
        "paw_msg":"कृपया 6-12 अक्षरों और संख्याओं का एक पासवर्ड दर्ज करें",
        "confirm_msg":"कृपया पासवर्ड की फिर से पुष्टि करें",
        "phone_msg":"कृपया फ़ोन सत्यापन कोड दर्ज करें",
        "con_paw":"पासवर्ड की पुष्टि कीजिये：",
        "exi_acc":"क्या आपके पास पहले से एक खाता मौजूद है，",
        "go_log":"लॉगिन> पर जाएं",
        "send_verify":"भेजनें",
        "retry_verify":"पुन: भेजें",
        "phone_confirm":"सही फ़ोन नंबर दर्ज करें!",
        "register_suc":"पंजीकरण सफल！",
        "user_not_mag":"उपयोगकर्ता नाम खाली नहीं हो सकता, कृपया भरें！",
        "No_null":"संख्या खाली नहीं हो सकती, कृपया भरें!",
        "correct_phone":"सही फ़ोन नंबर दर्ज करें!",
        "phone_vfy":"फ़ोन सत्यापन कोड खाली नहीं हो सकता, कृपया भरें!",
        "loss_account":"खाता हानि को रोकने के लिए, कृपया खाता सहेजें",
        "account_change":"खाते को केवल एक बार संशोधित किया जा सकता है, संशोधित करें पर क्लिक करें",
        "please_tick":"खाता पासवर्ड की पुष्टि करने के लिए कृपया टिक बटन पर क्लिक करें!",
        "save_suc":"सफलतापूर्वक बचाया！",
        "save_err":"बचाव असफल हुआ!कृपया मैन्युअल रूप से स्क्रीनशॉट लें！",

        "currency": "मुद्रा:",
        "language": "भाषा:",
    },
    "datum_text":{
        "datum_title":"जानकारी जमा करें",
        "bank_card":"बैंक कार्ड नंबर：",
        "inPlease_enter_the":"कृपया दर्ज करें...",
        "input_datum":"कृपया पहले डेटा दर्ज करें",
        "update_img":"तस्वीर डालिये",
        "select_update_img":"कृपया अपलोड की गई तस्वीर का चयन करें",
        "limit_type":"केवल JPG, JPEG, PNG अपलोड किए जा सकते हैं",
        "msg_update_data":"कृपया पहले डेटा अपलोड करें",
        "mag_update_pic":"कृपया पहले सही प्रारूप में चित्र अपलोड करें",
        "apply_succ":"आवेदन सफलतापूर्वक प्रस्तुत किया गया है, कृपया समीक्षा के लिए प्रतीक्षा करें"
    },
    "task_text":{
        "activity":"गतिविधि",
        "task":"कार्य",
        "announcement":"घोषणा",
        "sign":"साइन इन करें",
        "task_name":"मिशन का नाम：",
        "task_detail":"कार्य विवरण",
        "task_time":"कार्य प्रभावी समय:",
        "task_content":"कार्य सामग्री:"
    },
    "customer_text":{
        "jump_whatsapp": "whatsapp खाते को सफलतापूर्वक कॉपी किया जाता है, whatsapp पर पुनर्निर्देशित करने का अनुरोध करता है",
        "jump_telegram": "telegram खाते को सफलतापूर्वक कॉपी किया जाता है, telegram पर पुनर्निर्देशित करने का अनुरोध करता है",
        "jump_Messenger": "Messenger खाते को सफलतापूर्वक कॉपी किया जाता है, Messenger पर पुनर्निर्देशित करने का अनुरोध करता है",
        "jump_Viber": "Viber खाते को सफलतापूर्वक कॉपी किया जाता है, Viber पर पुनर्निर्देशित करने का अनुरोध करता है",
        "no_whatsapp": "whatsapp आपके डिवाइस पर स्थापित नहीं है",
        "no_telegram": "telegram आपके डिवाइस पर स्थापित नहीं है",
        "no_Messenger": "Messenger आपके डिवाइस पर स्थापित नहीं है",
        "no_Viber": "Viber आपके डिवाइस पर स्थापित नहीं है",

        "contact_customer":"ग्राहक सेवा से सम्पर्क करें",
        "not_ind_qq":"आपके डिवाइस पर QQ स्थापित नहीं है",
        "jump_wx":"WeChat खाते को सफलतापूर्वक कॉपी किया जाता है, WeChat पर पुनर्निर्देशित करने का अनुरोध करता है",
        "not_ind_wx":"WeChat आपके डिवाइस पर स्थापित नहीं है",
        "jump_mt":"MT ग्राहक सेवा खाता सफलतापूर्वक कॉपी किया जाता है, MT ग्राहक सेवा को पुनर्निर्देशित करने का अनुरोध करता है",
        "Online":"ऑनलाइन",
        "QQ":"QQ",
        "WECHAT":"WeChat",
        "MT":"MT",
        "CJ":"Q&A",
        "contact_online":"ग्राहक सेवा से सम्पर्क करें",
        "copy_wx":"WeChat ID कॉपी करें",
        "copy_mt":"एमटी नंबर कॉपी करें"
    },
    "msg_text":{
        "save_date":"संदेश एक महीने तक संग्रहीत किए जाते हैं",
        "message":"समाचार",
        "email":"मेल",
        "receive":"प्राप्त किया",
        "overdue":"समय सीमा समाप्त",
        "not_delete":"नष्ट नहीं किया जा सकता है, पहले इनाम इकट्ठा करें",
        "not_be_deleted":"लावारिस मेल को हटाया नहीं जाएगा"
    },
    "basic_text":{
        "basic_title":"मूलभूत जानकारी",
        "account":"खाता संख्या：",
        "nickname":"उपनाम：",
        "name":"पहला नाम：",
        "com_title":"संचार जानकारी",
        "qq":"Q Q：",
        "wx":"WeChat：",
        "phone":"मोबाइल फोन：",
        "email":"मेल बॉक्स："
    },
    "baes_text":{
        "unit":"युआन",
        "view":"राय",
        "yes":"हाँ",
        "no":"नहीं",
        "update":"अपडेट करें",
        "cancel":"रद्द करना",
        "mail_system":"सिस्टम मेल",
        "connected":"कनेक्ट हो रहा है, कृपया धैर्य रखें ...",
        "coin":"सोना",
    },
    "pre_details_text":{
        "detail":"रिचार्ज विवरण",
        "lxkf":"ग्राहक सेवा से संपर्क करें",
        "rkz":"जमा ...",
        "copy":"प्रतिलिपि",
        "order":"क्रम संख्या",
        "date":"रिचार्ज का समय",
        "czType":"रिचार्ज विधि",
        "transfer":"स्थानांतरण",
        "succ":"सफलता",
        "error":"असफलता",
        "audit":"समीक्षाधीन",
        "czSucc":"रिचार्ज फेल हो गया",
        "copy_succ":"सफलतापूर्वक कॉपी करें",
        "order_num":"क्रम संख्या"
    },
    "USDT_text":{
        "second_step":"चरण 2: USDT श्रृंखला की जानकारी",
        "url_name":"चैन का नाम",
        "alipay":"अली-पे के साथ भुगतान करें",
        "url":"चैन का पता ..."
    },
    "set_text":{
        "set_music":"संगीत सेटिंग्स",
        "switch_music":"संगीत स्विचन",
        "change_d_paw":"लॉगिन पासवर्ड को संशोधित करें",
        "change_t_paw":"वापसी पासवर्ड संशोधित करें",
        "version":"वर्तमान संस्करण",
        "huidu":"ग्रेस्केल",
        "swi_test":"बीटा संस्करण पर स्विच करें?",
        "swi_hui":"ग्रेस्केल संस्करण पर स्विच करना है या नहीं?",
        "old_paw_null":"पुराना पासवर्ड खाली नहीं हो सकता, कृपया भरें!",
        "new_paw_null":"नया पासवर्ड खाली नहीं हो सकता, कृपया भरें!",
        "old_paw_limit_length":"पुराना पासवर्ड 6-12 अंकों का है",
        "new_paw_limit_length":"नया पासवर्ड 6-12 अंकों और अक्षरों का एक संयोजन है",
        "new_paw_limit":"पुराना पासवर्ड 6 अंकों का होना चाहिए, कृपया फिर से भरें",
        "con_paw_null":"पुष्टि पासवर्ड खाली नहीं हो सकता, कृपया भरें!",
        "con_paw_consistent":"पासवर्ड और पुष्ट पासवर्ड असंगत हैं, कृपया फिर से भरें!",
        "new_old_paw_consistent":"नया पासवर्ड पुराने पासवर्ड के समान नहीं हो सकता, कृपया फिर से भरें!",
        "change_succ":"बधाई हो, आपने अपना पासवर्ड सफलतापूर्वक बदल दिया है, कृपया फिर से लॉग इन करें!",
        "tx_paw_null":"वापसी पासवर्ड खाली नहीं हो सकता है, कृपया भरें",
        "con_tx_paw":"वापसी की पुष्टि करें पासवर्ड खाली नहीं हो सकता, कृपया भरें",
        "tx_paw_consistent":"वापसी पासवर्ड पुष्टि पासवर्ड के साथ असंगत है, कृपया पुष्टि करें",
        "tx_paw_limit":"वापसी का पासवर्ड 6 अंकों का होना चाहिए, कृपया फिर से भरें",
        "paw_change_succ":"बधाई हो, आपने अपना पासवर्ड सफलतापूर्वक बदल दिया है",
        "latest_version":"यह ऐप का नवीनतम संस्करण है",
        "switch_server":"सर्वर स्विच करें",
        "switch_language":"भाषा को स्विच करें",
        "change_language_tips":"ऐप को पुनरारंभ के बाद कुछ पेजों की भाषा प्रभावी होगी।",
        "restart":"पुनरारंभ.",
    },
    "share_text":{
        "copy_wa":"कॉपी कॉपी",
        "save_img":"पिक्चर को सेव करना",
        "share_py":"मित्रों का मंडली साझा करें",
        "submit_audit":"समीक्षा जमा करें",
        "copy_succ":"सफलतापूर्वक कॉपी करें",
        "save_img_succ":"चित्र सफलतापूर्वक सहेजा गया",
        "save_err":"चित्र सहेजने में विफल।चित्रों को संग्रहीत करने के लिए इस एप्लिकेशन की अनुमति खोलने के लिए कृपया फ़ोन सेटिंग पृष्ठ पर जाएं",
        "share_go":"साझा：",
        "share_err_qq":"साझा करना विफल रहा, कृपया QQ स्थापित या जांचें और पुनः प्रयास करें",
        "share_err_wx":"साझा करना विफल रहा, कृपया WeChat स्थापित या जांचें और पुन: प्रयास करें",
        "share_err_wl":"बाइंडिंग विफल रही, कृपया नेटवर्क जांचें और पुनः प्रयास करें",
        "shareIntroduce_title":"ट्यूटोरियल साझा करें",
        "inviteFriends":"मित्रों को आमंत्रित करें"
    },
    "hot_text":{
        "dzyx":"दुनिया भर से लोकप्रिय वीडियो गेम को एक साथ लाना, उत्साह कम नहीं है, जीतने की दर अधिक है, और आप 10 मिलियन उपहार जीतने के लिए इंतजार कर रहे हैं!",
        "qbyx":"दुनिया के सबसे लोकप्रिय शतरंज और कार्ड गेम को इकट्ठा करें, उत्साह कम नहीं है, जीतने की दर अधिक है। दस मिलियन उपहार आप जीतने के लिए इंतजार कर रहे हैं!",
        "byyx":"दुनिया के सबसे लोकप्रिय मछली पकड़ने के खेलों को इकट्ठा करो, उत्साह कम नहीं है, जीतने की दर अधिक है। दस मिलियन उपहार आपके लिए इंतजार कर रहे हैं!",
        "rmqp":"लोकप्रिय शतरंज",
        "rmdz":"लोकप्रिय इलेक्ट्रॉनिक्स।",
        "rmby":"लोकप्रिय मछली पकड़ने का गेम",
        "ljyx":"जाओ",
    },
    "agent_text":{
        "my_id":"मेरी पहचान：",
        "under":"कल का सीधा कमीशन：",
        "offline":"कल का ऑफलाइन कमीशन：",
        "under_player":"प्रत्यक्ष खिलाड़ी：",
        "day_new":"कल जोड़ा गया：",
        "offline_player":"ऑफ़लाइन खिलाड़ी：",
        "bind_wx":"WeChat को बांधें",
        "share_rewards":"पुरस्कार बांटे：",
        "commission_ins":"आयोग निपटान की तारीख दैनिक निपटान है, दोस्तों या दोस्तों के सर्कल के साथ साझा करने से पुरस्कारों को साझा किया जा सकता है!"
    },
    "vip_text":{
        "my_level":"मेरा स्तर:",
        "current_code":"वर्तमान कोडिंग राशि:",
        "was_filed":"एडवांस जैकपॉट",
        "was_filed_info":"जब आप आगे बढ़ते हैं तो आप पुरस्कार प्राप्त कर सकते हैं",
        "weeks_amounts":"झोउ लिजिन",
        "weeks_amounts_info":"हर सोमवार को मुफ्त वितरण",
        "month_amounts":"मासिक उपहार",
        "month_amounts_info":"हर महीने की 1 तारीख को समय पर वितरित किया जाता है",
        "wash_code":"धो कोड",
        "wash_code_info":"उच्चतम फेरबदल अनुपात",
        "but_text":"अभी जाओ",
        "get_error":"सोने के सिक्के प्राप्त करने में विफल, कृपया सोने के सिक्कों को फिर से ताज़ा करें！",
        "amount_code":"कोड राशि",
        "title":"मेरे वीआईपी।",
        "backToMe":"मेरे में वापस करें",
        "me":"मैं"
    },
    "xima_text":{
        "game_type":"खेल का प्रकार",
        "dm_total":"प्रभावी शर्त राशि",
        "proportion":"उच्चतम फेरबदल अनुपात",
        "xm_amount":"कोड धोने की राशि",
        "can_led_take":" उपलब्ध",
        "xm_total":"कुल धुलाई राशि"
    },
    "PlayerCenter":{
        "note":"टिप्पणियों",
        "betting_record":"सट्टे का रिकॉर्ड",
        "trading_hours":"लेन-देन का समय",
        "trading_type":"सौदे का प्रकार",
        "change_amount":"राशि में परिवर्तन",
        "balance":"संतुलन",
        "today":"आजकल",
        "yesterday":"बिता कल",
        "a_month":"एक महीना",
        "all":"सब",
        "status":"व्यापारिक स्थिति",
        "chess":"शतरंज",
        "send_time":"भुगतान का समय",
        "note_num":"खेल-शर्त संख्या",
        "betting_amount":"बेट राशि",
        "has_been":"से सम्मानित किया",
        "gaming":"गेमिंग प्लेटफ़ॉर्म",
        "jbxx":"मूल जानकारी",
        "zhmx":"खाते का विवरण",
        "zdlb":"नोटों की सूची",
        "my_vip":"मेरे वीआईपी",
        "save":"सहेजें",
        "edit":"संपादित करें",
        "currencyType":"मुद्रा परिवर्तित करें",

    },
    "RechargeLayer":{
        "note":"टिप्पणियों",
        "often_play":"खिलाड़ियों को अक्सर खेलने वाली त्वरित राशि",
        "between":"कृपया 1 और 100 के बीच राशि दर्ज करें",
        "gift100":"100% मुफ्त",
        "payment_account":"खाता प्राप्त करना",
        "payee":"आदाता",
        "where":"बैंक खाता",
        "depositors":"कृपया जमाकर्ता का वास्तविक नाम भरें",
        "note_info":"जानकारी को दूर करता है",
        "step":"पहला चरण: भुगतान के QR कोड को स्कैन करें और रिचार्ज करें",
        "step2":"चरण 2: अपनी रिचार्ज जानकारी भरें और रिचार्ज सबमिट करें",
        "session":"हाल की बातचीत",
        "official":"आधिकारिक प्रमाणीकरण",
        "gift2":"2% मुफ्त",
        "channel":"* कृपया एक रिचार्ज चैनल का चयन करें  n * कृपया चैनल चुनने से पहले विनिमय दर को ध्यान से देखें",
        "qr_code":"रक्षा करनासहेजें दो आयामी कोड",
        "digital_currency":"डिजिटल मुद्रा रिचार्ज चैनल 1",
        "step_1":"चरण 1: USDT राशि चुनें",
        "formula":"खाता राशि के लिए अंतिम पुनर्भरण के लिए गणना सूत्र: 70.86 = 10.1234USDT * वर्तमान विनिमय दर 7 युआन",
        "step3":"चरण 3: वापसी की जानकारी प्रदान करें",
        "actual_account":"USDT की वास्तविक राशि प्राप्त हुई",
        "poundage":"हैंडलिंग शुल्क 0-50USDT",
        "instr":"* कृपया बाईं तस्वीर में दिखाए अनुसार सख्ती से भरें! * यदि आप गलत तरीके से भरते हैं, तो आप समय पर नहीं पहुंच पाएंगे！",
        "not_account":"रिचार्ज अभी तक नहीं आया है?",
        "rate":"विनिमय दर: 1USDT = 99 युआन",
        "prompt_info":"शीघ्र जानकारी",
        "czjl":"रिचार्ज रिकॉर्ड",
        "czjc":"रिचार्ज ट्यूटोरियल",
        "ljcz":"अब रिचार्ज करें",
        "czje":"रिचार्ज की राशि।",
        "zfpz":"भुगतान वाउचर",
        "save_code":"क्यूआर कोड को सहज करें।",
        "xuanchuan":"        ",
        "usdt_address":"USDT：",
        "syb":"पिछला कदम",
        "complete":"पूरा हो गया",
        "usdt_num":"USDT：",
        "go_recharge":"रिचार्ज के लिए जाएं",
        "back":"वापस",
        "creat_order":"आदेश बनाएं",
        "real_usdt":"USDT",
        "sxf":"हैंडलिंग फीस",
        "date":"समय",
        "state":"स्थिति",
        "jine":"राशि",
        "detail":"विवरण",
        "rechargeCourse":"रिचार्ज ट्यूटोरियल",
        "currency_symbol":"₹",
        "currency_word":"Rs",
        "rate2coin":"विनिमय दर:1 सोने का सिक्का = ",
        "get_coins":"प्राप्त सोने के सिक्के:",
        "get_money":"रकम प्राप्त:",
        "go_pay": "प्रतिलिपि सफल है। क्या आप तुरंत भुगतान करना चाहते हैं?",
        "pay_now": "तुरंत भुगतान करें",
        "pay_not_support": "अस्थायी रूप से भुगतान नहीं किया जा सकता है!",
    },
    "SettingLayer":{
        "bind_equi":"डिवाइस बाइंडिंग",
        "basic_info":"मूलभूत जानकारी",
        "account":"खाता संख्या:",
        "level":"स्तर:",
        "set_sound":"ध्वनि सेटिंग",
        "music":"संगीत",
        "sound":"ध्वनि प्रभाव",
        "switch_music":"संगीत स्विचन",
        "song2":"मरते वक्त मुझे प्यार करना है",
        "song1":"गीत १",
        "inp_landing_paw":"कृपया लॉगिन पासवर्ड दर्ज करें",
        "inp_old_paw":"कृपया पुराना पासवर्ड डालें",
        "old_paw":"पुराना पासवर्ड：",
        "inp_new_paw":"कृपया एक नया पासवर्ड दर्ज करें",
        "new_paw":"नया पासवर्ड：",
        "con_new_paw":"नए पासवर्ड की पुष्टि करें",
        "con_paw":"पासवर्ड की पुष्टि कीजिये：",
        "check_update":"अद्यतन के लिए जाँच",
        "determine":"निर्धारित",
        "bind_shuom1":"* डिवाइस को बाइंड करने के बाद, आप सीधे बाउंड डिवाइस में लॉग इन करने के लिए क्विक लॉगिन का उपयोग कर सकते हैं।",
        "bind_shuom2":"* जल्दी से एक खाते को पंजीकृत करने के लिए, वर्तमान डिवाइस स्वचालित रूप से बाध्य है।",
        "bind_shuom3":"* डिवाइस को बांधने के बाद, आप पहचान को सत्यापित कर सकते हैं और अनबाइंड कर सकते हैं।",
        "bind_shuom4":"* पहचान सत्यापित करने के लिए, आपको खाते के लॉगिन पासवर्ड को दर्ज करना होगा।",
        "bind_shuom5":"* कृपया सावधानी बरतें！",
        "bind_shuom6":"वर्तमान डिवाइस बाध्य किया गया है",
        "bind_shuom7":"अन्य उपकरण पहले से ही बाध्य हैं",
        "landing_paw":"लॉग इन पासवर्ड：",
        "test":"परीक्षण का वातावरण",
        "huidu":"ग्रेस्केल पर्यावरण",
        "standbyTest":"वैकल्पिक परीक्षण वातावरण",
        "mute_all":"सभी को म्यूट करें",
        "change_account":"खातों को स्विच करें",
        "confirm_change":"संशोधन की पुष्टि करें",
        "confirm_bind":"डिवाइस बाध्यकारी",
        "unbind_device":"डिवाइस को अनबाइंड करें",
        "unbind":"अनबाउंड करें"
    },
    "Task":{
        "share_task":"शेयर कार्य",
        "MG_electronic":"एमजी इलेक्ट्रॉनिक्स",
        "cash":"नकद",
        "complete":"को खत्म करने",
        "application":"को लागू करने",
        "refused":"अस्वीकृत",
        "disclose_data":"जानकारी जमा करें",
        "friends_account":"दोस्तों खाता है",
        "submit":"प्रस्तुत",
        "Audit_failure":"ऑडिट विफलता",
        "submit_creenshot":"स्क्रीनशॉट जमा करें",
        "apply_reward":"इनाम के लिए आवेदन करें",
        "first_step_pic":"चरण 1: साझा करने के लिए नीचे दिए गए आइकन पर क्लिक करें, फिर एक स्क्रीनशॉट लें",
        "second_step_pic":"चरण 2: एक स्क्रीनशॉट जमा करें",
        "pic_limit":"केवल JPG, JPEG, PNG अपलोड किए जा सकते हैं, 1M से अधिक नहीं",
        "pic_limit_size":"अपलोड छवि का आकार 1M से अधिक नहीं हो सकता",
        "update_pic":"तस्वीर डालिये",
        "inp_account":"कृपया पहले खाता संख्या दर्ज करें",
        "video_limit_size":"अपलोड वीडियो का आकार 2M से अधिक नहीं हो सकता",
        "first_step_video":"चरण 1: साझा करने के लिए नीचे दिए गए आइकन पर क्लिक करें, फिर वीडियो रिकॉर्ड करें",
        "second_step_video":"चरण 2: वीडियो सबमिट करें",
        "video_limit":"केवल MP4, AVI, MOV प्रारूप अपलोड करें, 2M से अधिक नहीं",
        "update_video":"विडियो को अॅॅपलोड करें",
        "task_details":"कार्य विवरण",
        "Task_details":"कार्य विवरण：",
        "task_name":"मिशन का नाम：",
        "task_state":"कार्य विवरण：",
        "share":"इसे शेयर करें",
        "share_go":"साझा:",
        "submit_pic":"चित्र प्रस्तुत करें",
        "submit_video":"वीडियो सबमिट करें",
        "video_update_limit":"या MP4, AVI, MOV प्रारूप अपलोड करें, 2M से अधिक नहीं",
        "task_progress":"कार्य प्रगति：",
        "know":"मुझे पता है",
        "q_update_pic":"कृपया पहले चित्र अपलोड करें",
        "q_update_video":"कृपया पहले वीडियो अपलोड करें",
        "activit_Shut":"कार्य गतिविधि बंद है",
        "Qbind_wx":"कृपया पहले WeChat को बांधें",
        "Application_success":"आवेदन सफल है, कृपया समीक्षा के लिए प्रतीक्षा करें",
        "Succ_application_Award":"इनाम के लिए सफल आवेदन",
        "task_ShutDown":"शेयरिंग कार्य बंद है",
        "btn_choose":"चुनें",
        "editTips":"अपलोड की इमेज का चयन करें।"
    },
    "ThirdGamesListLayer":{
        "xsj":"नई दुनिया शतरंज",
        "tall_game":"कुल 1 खेल",
        "inp_game":"कृपया खेल का नाम दर्ज करें"
    },
    "TuiGuangLayer":{
        "title":"एजेंट प्रचार",
        "my_agent":"मेरा एजेंट",
        "agent_recruit":"एजेंट भर्ती",
        "agent_introduced":"एजेंट परिचय",
        "players_query":"खिलाड़ी क्वेरी",
        "results_query":"प्रदर्शन क्वेरी",
        "rich_list":"धन सूची",
        "my_id":"मेरी पहचान：",
        "under":"कल का सीधा कमीशन：",
        "offline":"कल का ऑफलाइन कमीशन：",
        "under_player":"प्रत्यक्ष खिलाड़ी：",
        "day_new":"कल जोड़ा गया：",
        "offline_player":"ऑफ़लाइन खिलाड़ी：",
        "share_rewards":"पुरस्कार बांटे：",
        "commission_ins":"आयोग निपटान की तारीख दैनिक निपटान है, दोस्तों या दोस्तों के सर्कल के साथ साझा करने से पुरस्कारों को साझा किया जा सकता है!",
        "save_qr_code":"QR कोड सेव करें",
        "copy":"प्रतिलिपि",
        "bind_wx":"WeChat को बांधें",
        "Imm_receive":"अभी ले आओ",
        "share_detail":"विवरण साझा करें",
        "get_record":"संग्रह का रिकॉर्ड",
        "historyCom":"ऐतिहासिक कुल कमीशन",
        "canReceive":"उपलब्ध कमीशन ",
        "zhishu_renshu":"प्रत्यक्ष रिपोर्ट की संख्या:",
        "tall_bets_today":"कुल दांव आज वैध：",
        "inp_id":"कृपया आईडी दर्ज करें",
        "query":"पूछताछ",
        "reset":"रीसेट",
        "bets_today":"मान्य आज दांव लगाता है",
        "total_bets":"कुल प्रभावी दांव",
        "directly_num":"प्रत्यक्ष रिपोर्ट की संख्या",
        "operation":"ऑपरेटिंग",
        "details":"विवरण >>",
        "date":"दिनांक.",
        "under_new":"सीधे जोड़ा गया",
        "team_new":"नई टीम",
        "directly_under":"प्रत्यक्ष कमीशन छूट",
        "total_amount":"कुल छूट",
        "reward":"इनाम",
        "contact":"अपने गुरु से संपर्क करें",
        "ranking":"पद",
        "player_info":"खिलाड़ी की जानकारी",
        "rebate_month":"आयोग इस महीने में छूट",
        "rewards_month":"इस महीने पुरस्कार बांटे",
        "detailed_info":"विवरण",
        "zhuce_shijian":"पंजीकरण का समय：",
        "jtyxtz":"मान्य दांव आज:",
        "tdrsxz":"टीम का आकार (नया)：",
        "jrtdyxtz":"आज की टीम वैध दांव:",
        "directly_num_new":"प्रत्यक्ष रिपोर्ट की संख्या (नई)：",
        "zuoriyongjing":"कल का कमीशन:",
        "commission_payable":"वापस लेने योग्य कमीशन：",
        "lishizongyong":"ऐतिहासिक कुल कमीशन:",
        "zyxtz":"कुल प्रभावी दांव：",
        "agent_commission":"एजेंसी कमीशन",
        "share_commission":"शेयर कमीशन",
        "team_num":"टीम की संख्या",
        "not_directly_under":"गैर-प्रत्यक्ष छूट",
        "account":"खाता संख्या",
        "between":"संबंध",
        "effective_betting":"प्रभावी शर्त / छूट राशि",
        "ratio":"रिबेट अनुपात",
        "total":"संपूर्ण",
        "share":"इसे शेयर करें"
    },
    "WithdrawLayer":{
        "self_help":"स्वयं सेवा वापसी",
        "withdrawal_record":"नाम वापसी",
        "wallet_management":"बटुआ प्रबंधन",
        "inp_withdrawal_amount":"कृपया वापसी राशि दर्ज करें",
        "warm_prompt":"टिप्स",
        "current_need":"अभी भी जरूरत है",
        "can_carry":"नकदी निकासी से पहले बहता पानी",
        "adjust_amount":"नकद निकासी राशि को समायोजित करने के लिए डॉट्स खींचें",
        "bank":"ICBC",
        "change_bank_card":"बैंक कार्ड बदलें",
        "not_bind_card":"आपने फिलहाल बैंक कार्ड नहीं बांधा है, कृपया बाँधने के लिए जाएँ",
        "not_tixian_paw":"आपने विद्ड्रॉअल पासवर्ड सेट नहीं किया है, कृपया विथड्रॉल पासवर्ड सेट करें",
        "tixian_paw":"वापसी का पासवर्ड",
        "set6num_paw":"कृपया 6 अंकों का पासवर्ड सेट करें",
        "confirm_password":"पासवर्ड की पुष्टि कीजिये",
        "again_confirm_password":"कृपया पुष्टि करने के लिए पासवर्ड फिर से दर्ज करें",
        "inp_tixian_paw":"कृपया वापसी पासवर्ड दर्ज करें",
        "topUp_failure":"रिचार्ज फेल हो गया",
        "bank_paragraph":"बैंक से निकासी",
        "add_card":"बैंक कार्ड जोड़ें",
        "cardholder_name":"कृपया कार्डधारक का नाम दर्ज करें",
        "cardholder":"कार्डधारक：",
        "card_code":"बैंक कार्ड खाता：",
        "inp_bank_card_code":"कृपया बैंक कार्ड नंबर दर्ज करें",
        "inp_bank_address":"कृपया बैंक का पता दर्ज करें",
        "bank_address":"खाता खोलने का पता：",
        "bank_address_msg":"अनुस्मारक: कृपया सही ढंग से खाता बैंक का चयन करें और अपने वास्तविक नाम को बांधें। इसे सीधे निपटान के दौरान परिवर्तित खाते में स्थानांतरित कर दिया जाएगा। अपने धन की सुरक्षा के लिए, आप इसे बाध्यकारी होने के बाद बदल नहीं सकते। यदि आपको इसे संशोधित करने की आवश्यकता है, तो कृपया ग्राहक सेवा से संपर्क करें।。",
        "choose_bank":"बैंक का चयन करें：",
        "inp_aliPay_name":"कृपया Alipay का वास्तविक नाम दर्ज करें",
        "inp_aliPay_code":"कृपया Alipay खाता दर्ज करें",
        "name":"नाम:",
        "aliPay_account":"Alipay खाता:",
        "aliPay_account_msg":"अनुस्मारक: कृपया सही ढंग से Alipay का चयन करें, और इसे सीधे निपटान के दौरान परिवर्तित खाते में स्थानांतरित कर दिया जाएगा। अपने धन की सुरक्षा के लिए, आप इसे बाध्यकारी होने के बाद बदल नहीं सकते। यदि आपको संशोधित करने की आवश्यकता है, तो कृपया ग्राहक से संपर्क करें।。",
        "inp_tixian_dizhi":"कृपया वापसी का पता दर्ज करें",
        "rate":"विनिमय दर।",
        "daozhangUSDT":"USDT",
        "confirm_tixian":"निकासी की पुष्टि करें",
        "max":"सबसे बड़ा",
        "confirm_submit":"प्रतिबद्ध की पुष्टि करें",
        "tixian_time":"निकासी का समय",
        "jine":"राशि.",
        "state":"स्थिति",
        "order_info":"आदेश की जानकारी",
        "confirm_bind":"बाइंडिंग की पुष्टि करें",
        "confirm_select":"बाइंडिंग की पुष्टि करें",
        "select_bank_card":"बैंक कार्ड का चयन करें",
        "bizhong_xuanze":"मुद्रा चयन:",
        "tixian_dizhi":"वापसी का पता:",
        "more_than_0": "निकासी राशि 0 से अधिक होनी चाहिए",
        "current_need_adjust_amount":"नकदी निकालने के लिए आपको अभी भी <color = # 00ff00> 0 </ c> प्रवाह की आवश्यकता है",
    },
    "XimaLayer":{
        "title":"सौदेबाजी की चिप",
        "selfHelp_washing":"स्वयं धोने का कोड",
        "xima_record":"वॉश कोड रिकॉर्ड",
        "xima_proportion":"धो कोड अनुपात",
        "fishing_game":"मछली पकड़ने का खेल",
        "to_complete":"को खत्म करने",
        "receive":"प्राप्त करना",
        "chess":"शतरंज",
        "fishing":"मछली पकड़ना",
        "electronic":"इलेक्ट्रोनिक",
        "reality":"वास्तविक व्यक्ति",
        "sports":"शारीरिक शिक्षा",
        "eSports":"जुआ",
        "lottery":"लॉटरी",
        "game":"खेल",
        "key_get":"एक-क्लिक संग्रह",
        "get_time":"संग्रह का समय",
        "damaliang":"प्रभावी शर्त राशि",
        "xima_amount":"कोड धोने की राशि",
        "details":"विवरण",
        "viewI":"देखें >>",
        "xima_details":"कोड धोने का विवरण",
        "heitao_chess":"कुक्म के पत्ते",
        "chess_game":"विशेष प्रकार के बोर्ड या पट्टे के खेल जैसे शतरंज, साँप सीढ़ी आदि",
        "sports_events":"खेल की घटनाए",
        "electronic_game":"इलेक्ट्रॉनिक खेल",
        "lottery_betting":"लॉटरी का दांव",
        "real_video":"लिव विडियो",
        "eSports_game":"ई खेल खेल",
        "game_name":"खेल का नाम",
        "click_details":"विवरण के लिए क्लिक करें",
        "tianmei_chess":"तियानमेई शतरंज",
        "detailsI":"विवरण >>",
        "xima_range":"कोड धोने की सीमा",
        "vip_level":"वीआईपी स्तर",
        "tournament":"ई-खेल",
        "lottery_game":"लॉटरी का खेल"
    },
    "Signal":{
        "switch":"स्विच लाइन",
        "speed":"त्वरण रेखा",
        "choose":"लाइन का चयन करें",
        "reconnect":"पुनः कनेक्ट",
        "helpful_hints":"फ्रेंडली रिमाइंडर: देरी जितनी कम होगी, नेटवर्क उतना ही बेहतर होगा",
        "is_msg":"यह एक संदेश है",
        "in_test":"चेकिंग",
        "general":"सामान्य",
        "smooth":"चिकनी",
        "speed1":"गति",
        "current_use":"वर्तमान में उपयोग करें"
    },
    "general":{
        "name":"नाम",
        "activity":"व्यापक गतिविधियाँ",
        "xzsm":"पता प्रकाशक, किसी भी समय नवीनतम इंस्टॉलेशन पता प्राप्त करें。",
        "wszl":"पूरी सामग्री",
        "qdcj":"साइन-इन बोनस",
        "xtyj":"सिस्टम मेल",
        "xxzx":"संदेश केंद्र",
        "bt":"शीर्षक",
        "sj":"समय",
        "nr":"सामग्री",
        "xx":"समाचार",
        "dlq":"मिल सकते हैं",
        "ylq":"मिल गया",
        "ygq":"समयसीमा समाप्त है",
        "ready_all":"सब पढ़े गए",
        "del_all":"सभी को हटाएं",
        "get_all":"सब मिलें"
    },
    "EllipticalStage":{
        "musicNmae":"जीत के लिए"
    },
    "CheckHot":{
        "update_msg":"एक नया संस्करण अपडेट का पता चला है और आपके लिए डाउनलोड पूरा हो गया है। अपडेट पूरा करने के लिए क्लिक करें!",
        "update":"अपडेट करें",
        "lack_resources":"कला संसाधनों की कमी",
        "kaiyuan_chess":"काइयाँ शतरंज",
        "leyou_chess":"ले टूर शतरंज",
        "xinshijie_chess":"नई दुनिया शतरंज",
        "ag_electronic":"एजी इलेक्ट्रॉनिक्स",
        "pg_electronic":"पीजी इलेक्ट्रॉनिक्स",
        "mg_electronic":"एमजी इलेक्ट्रॉनिक्स"
    },
    "HallUI":{
        "copy_succ":"सफलतापूर्वक कॉपी करें",
        "moment_open":"अभी तक नहीं खुला",
        "no_announcement":"कोई घोषणा सामग्री नहीं",
        "tmpled_err":"टेम्पलेट कॉन्फ़िगरेशन त्रुटि, ग्राहक सेवा से संपर्क करें",
        "game_maintain":"इस खेल का रखरखाव जारी है",
        "game_loading":"खेल लोड कर रहा है",
        "get_err":"सोने के सिक्के प्राप्त करने में विफल, कृपया सोने के सिक्कों को फिर से ताज़ा करें!",
        "login":"लॉगिन",
        "register":"पंजीकृत",
        "copy_id":"ID",
        "huodong":"गतिविधि",
        "task":"कार्य.",
        "setting":"सेटिंग",
        "remen":"हॉट",
        "qipai":"शतरंज.",
        "buyu":"मछली पकड़ने का गेम",
        "zhenren":"वास्तविक लोग",
        "dianzi":"इलेक्ट्रॉनिक.",
        "tiyu":"स्पोर्टेस",
        "caipiao":"लॉटरी",
        "dianjing":"ई-प्रतियोगिता",
        "tuiguangdaili":"एजेंट प्रचार",
        "xima":"सौदेबाजी की चिप",
        "xiaoxi":"समाचार",
        "kefu":"ग्राहक सेवा",
        "xiufugongju":"सुधार का उपकरण",
        "gengduo":"अधिक",
        "qiandao":"लॉग-इन",
        "paihangbang":"रैंक",
        "gonggao":"नोटिस",
        "tixian":"निकासी",
        "chongzhi":"रिचार्ज",
        "xianshilingqu":"सीमित समय के लिए लीजिए।",
        "remenyouxi":"हॉट गेम",
        "zuijingchangwan":"आजकल खेलते हैं",
        "play_now":"जाओ"
    },
    "BasicsJS":{
        "tall":"कुल मिलाकर",
        "minGame":"छोटा खेल",
        "play_game":"हाल ही में कोई गेम नहीं खेला",
        "editor_succ":"सफलतापूर्वक संपादित करें",
        "yi_bind":"बाउंड",
        "wu_bind":"अबाध",
        "inp_amount":"कृपया रिचार्ज राशि दर्ज करें",
        "inp_correct_amount":"कृपया सही रिचार्ज राशि दर्ज करें",
        "no_login_yinshang":"अपंजीकृत बैंक व्यापारी",
        "gift":"उपहार",
        "voucher_cannot_empty":"भुगतान वाउचर खाली नहीं हो सकता",
        "pic_loading":"लॉग-इन उपयोगकर्ता प्रतिधारण उन उपयोगकर्ताओं को संदर्भित करता है जो एक निश्चित समय पर नए जोड़े जाते हैं और अभी भी समय की अवधि के बाद हमारे उत्पादों में लॉग इन होते हैं। इस सूचक का उपयोग उपयोगकर्ता की चिपचिपाहट और वफादारी को समझने के लिए किया जा सकता है।",
        "amount_between":"के बीच की राशि",
        "card":"कार्ड",
        "note_info":"खाता तेजी से प्राप्त करने के लिए टिप्पणियों की जानकारी भरें",
        "credit_cord":"कार्ड नंबर प्राप्त करना",
        "rate":"विनिमय दर",
        "not_channel":"रिचार्ज चैनल मौजूद नहीं है, कृपया ग्राहक सेवा से संपर्क करें",
        "select_amount":"कृपया रिचार्ज राशि का चयन करें",
        "confirm_cancellation_order":"क्या आप ऑर्डर रद्द करना सुनिश्चित करते हैं",
        "been_submit":"आदेश प्रस्तुत किया गया है, कृपया धैर्यपूर्वक प्रतीक्षा करें",
        "Eventually_topUp_amount":"अंतिम रिचार्ज राशि है",
        "current_rate":"वर्तमान विनिमय दर",
        "Outstanding_orders":"आपके पास एक अधूरा आदेश है, चाहे जारी रखना है",
        "Continue":"लगे रहो",
        "Cancel_order":"आदेश रद्द",
        "bind_succ":"सफलतापूर्वक बांधें",
        "inp_paw":"कृपया पहले पासवर्ड दर्ज करें",
        "remove_bind_succ":"सफलतापूर्वक अनबंड करें",
        "first":"प्रथम",
        "day":"दिन",
        "Sports_eSports":"खेल ई खेल",
        "directly":"सीधे के तहत",
        "not_directly":"सीधे तौर पर नहीं",
        "amount_not_null":"वापसी की राशि खाली नहीं हो सकती, कृपया भरें",
        "WithdrawalAmount":"निकाली गयी राशि",
        "Qbind":"कृपया पहले बांध लें",
        "moment_not_bind":"आप वर्तमान में बाध्य नहीं हैं",
        "QgoBind":"कृपया बांधने जाएं",
        "replace":"बदलने के",
        "between":"के बीच",
        "request_submit":"नाम वापसी अनुरोध प्रस्तुत किया गया है",
        "ContinueToCarry":"वापस लेना जारी रखें",
        "GiveUpWithdrawal":"वापसी छोड़ दी",
        "Qxuanding":"युक्ति: कृपया सही ढंग से चयन करें",
        "jiesuanshihou":"इसे सीधे इसमें स्थानांतरित किया जाएगा",
        "zhuanghaowanquan":"आपके धन की सुरक्षा के लिए खाता संख्या, को बदलने के बाद नहीं बदला जा सकता है। यदि आपको इसे संशोधित करने की आवश्यकता है, तो कृपया ग्राहक सेवा से संपर्क करें।",
        "phoneNo":"फ़ोन नंबर",
        "add":"में जोड़े",
        "updateTimeout":"अपडेट टाइमआउट की जाँच करें, कृपया सुनिश्चित करें कि आपका नेटवर्क सामान्य है",
        "retry":"पुन: प्रयास करें",
        "err_retry":"फ़ाइल डाउनलोड करने में त्रुटि हुई, कृपया पुनः प्रयास करें",
        "err_check_network":"फ़ाइल डाउनलोड करने में विफल, कृपया पुष्टि करें कि आपका नेटवर्क सामान्य है या नहीं",
        "no_get_data":"कोई संसाधन अद्यतन प्राप्त नहीं हुआ है, कृपया बाद में पुनः प्रयास करें",
        "network_retry":"नेटवर्क डिस्कनेक्ट हो गया है, कृपया जांचें कि क्या आपका नेटवर्क कनेक्शन सामान्य है",
        "Quit_game":"खेल से बाहर निकलें",
        "ReturnHall":"लॉबी में लौटें",
        "daozhangUSDT":"USDT राशि प्राप्त हुई"
    }
};
